export function isLikeMessage(message: Vingle.Talk.IMessage): boolean {
  return Boolean(message.relation && message.relation.liked);
}
